import { Role, User } from './user';

export enum IdPType {
  OKTA = 'okta',
  AZURE_AD = 'azure_ad',
  GOOGLE = 'google',
}

/**
 * Request payload for creating an SSO organization.
 */
export interface CreateSSOOrganizationRequest {
  name: string;
  enable_sso: true;
  zitadel_org_id: string;
  subdomain: string;
  idp_type: IdPType;
  logo_url?: string;
  seat_limit?: number;
}

/**
 * Request payload for creating a legacy (password) organization.
 */
export interface CreateLegacyOrganizationRequest {
  name: string;
  enable_sso?: false;
}

/**
 * Response from seat info endpoint.
 */
export interface SeatInfoResponse {
  seat_limit: number;
  seats_used: number;
  seats_available: number;
}

/**
 * User status based on membership.
 */
export type UserStatus = 'active' | 'inactive';

/**
 * Zitadel user with derived status.
 */
export interface ZitadelUser extends User {
  zitadel_user_id: string;
  status: UserStatus;
  first_access_at: string | null;
  last_access_at: string | null;
}

/**
 * Response from list users endpoint.
 */
export interface UserListResponse {
  users: ZitadelUser[];
  total: number;
  active_count: number;
  inactive_count: number;
  seat_limit: number;
  seats_available: number;
}

/**
 * Response from activate/deactivate endpoints.
 */
export interface UserActionResponse {
  status: string;
  message: string;
  user: ZitadelUser;
}

/**
 * Response from available roles endpoint.
 */
export interface AvailableRolesResponse {
  status: string;
  roles: Array<Role>;
}

/**
 * Response from update SSO user roles endpoint.
 */
export interface UpdateSsoRolesResponse {
  status: string;
  message: string;
  user: ZitadelUser;
}
